import React, { useState, useEffect, useRef, useMemo } from "react";
import { motion } from "framer-motion";
import { ReactComponent as CalenderIcon } from "../../../../assets/icons/calender.svg";
import { ReactComponent as DownArrow } from "../../../../assets/icons/down-arrow.svg";
import { ReactComponent as PlusIcon } from "../../../../../myfin_v2/assets/icons/plusBlack.svg";
import { ReactComponent as RemoveIcon } from "../../../../../myfin_v2/assets/icons/removeLoansIcons.svg";
import rupeeIcon from "../../../../assets/icons/Rupee.png";
import investmentRegisterCss from "../../../../css/investmentRegister.module.css";
import WarningIcon from "../../../../assets/icons/warningIcon.png";
import Arrow from "../../../../assets/icons/ArrowCircle.png";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import CommonDatePicker from "../../../../elements/CommonDatePicker";
import ConsolEntryConfigModal from "./ConsolEntryConfigModal";
export const css = investmentRegisterCss;


export const CLASS_OF_SHARE_OPTIONS = [
    { value: "Equity",     label: "Equity" },
    { value: "Preference", label: "Preference" },
    { value: "Right Issue",     label: "Right Issue" },
    { value: "Lease Liability",  label: "Lease Liability" },
];

export const SUB_CLASS_OPTIONS = [
  { value: "Class A", label: "Class A" },
  { value: "Class B", label: "Class B" },
  { value: "Class C", label: "Class C" },
  { value: "Other", label: "Other" },
];

export const RELATIONSHIP_OPTIONS = [
    { value: "Subsidiary",        label: "Subsidiary" },
    { value: "Associate Company", label: "Associate Company" },
    { value: "Joint Venture",     label: "Joint Venture" },
    { value: "Investment",     label: "Investment" },
    
];

 const formatIndianNumber = (val) => {
        if (val == null) return "";
        const num = Number(val);
        if (isNaN(num)) return String(val);

        if (num < 0) {
            return "(" + (-1 * num).toLocaleString("en-IN") + ")";
        }
        return num.toLocaleString("en-IN");
        };

export const CustomDropdown = ({ label, options, value, onChange, placeholder, fullWidth }) => {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");
    const [activeIndex, setActiveIndex] = useState(-1);
    const ref = useRef(null);

    const selected = (options || []).find(o => o.value === value || o.label === value);

    useEffect(() => {
        setActiveIndex(-1);
    }, [search, open]);

    const handleKeyDown = (e) => {
        if (!open && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
            setOpen(true);
            return;
        }
        if (e.key === "ArrowDown") {
            e.preventDefault();
            setActiveIndex(prev => (prev < filteredOptions.length - 1 ? prev + 1 : prev));
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            setActiveIndex(prev => (prev > 0 ? prev - 1 : prev));
        } else if (e.key === "Enter") {
            e.preventDefault();
            if (open && activeIndex >= 0 && activeIndex < filteredOptions.length) {
                const opt = filteredOptions[activeIndex];
                onChange(opt.value);
                setSearch(opt.label);
                setOpen(false);
            }
        }
    };

    useEffect(() => {
        if (selected) {
            setSearch(selected.label);
        } else if (value) {
            setSearch(value);
        } else {
            setSearch("");
        }
    }, [value, options, selected]);

    useEffect(() => {
        const handleOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
                if (selected) {
                    setSearch(selected.label);
                } else if (value) {
                    setSearch(value);
                }
            }
        };
        document.addEventListener("mousedown", handleOutside);
        return () => document.removeEventListener("mousedown", handleOutside);
    }, [selected, value]);

    const list = options || [];
    let filteredOptions = list;
    if (!(selected && search === selected.label) && search && search.trim()) {
        filteredOptions = list.filter((opt) =>
            String(opt.label || "").toLowerCase().includes(search.toLowerCase())
        );
    }

    const handleInputChange = (e) => {
        const val = e.target.value;
        setSearch(val);
        setOpen(true);
        const matched = (options || []).find(
            (o) => o.label.toLowerCase() === val.toLowerCase() || String(o.value).toLowerCase() === val.toLowerCase()
        );
        if (matched) {
            onChange(matched.value);
        } else {
            onChange(val);
        }
    };

    return (
        <div className={fullWidth ? css.fullWidth : ""}>
            {label && <label className={css.label}>{label}</label>}
            <div ref={ref} style={{ position: "relative" }}>
                <div className={css.dropdownField} onClick={() => setOpen(true)} style={{ display: "flex", alignItems: "center" }}>
                    <input
                        className={css.input}
                        style={{ 
                            border: "none", 
                            padding: 0, 
                            height: "auto", 
                            flex: 1, 
                            color: selected && search === selected.label ? "#205a46" : "#111", 
                            fontSize: "14px",
                            backgroundColor: "transparent",
                            outline: "none"
                        }}
                        value={search}
                        placeholder={placeholder}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyDown}
                    />
                    <motion.span animate={{ rotate: open ? 180 : 0 }} transition={{ duration: 0.2 }} className={css.chevron} onClick={(e) => { e.stopPropagation(); setOpen(!open); }}>
                        <DownArrow width={18} height={18} />
                    </motion.span>
                </div>
                {open && (
                    <div className={css.dropdownMenuScrollable} style={{ zIndex: 999 }}>
                        {filteredOptions.length > 0 ? filteredOptions.map((opt, i) => (
                            <div
                                key={i}
                                className={`${css.dropdownItem} ${opt.value === value || activeIndex === i ? css.dropdownItemActive : ""}`}
                                style={activeIndex === i ? { backgroundColor: "#f4faf5", color: "#2d8861" } : {}}
                                onClick={() => { 
                                    onChange(opt.value); 
                                    setSearch(opt.label);
                                    setOpen(false); 
                                }}
                            >
                                {opt.label}
                            </div>
                        )) : (
                            <div className={css.dropdownItem} style={{ color: "#b3c0bd" }}>No options found</div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export const TextInput = ({ label, placeholder, value, onChange, fullWidth, readOnly }) => (
    <div className={fullWidth ? css.fullWidth : ""}>
        <label className={css.label}>{label}</label>
        <input
            className={css.input}
            placeholder={placeholder}
            value={value || ""}
            onChange={e => onChange && onChange(e.target.value)}
            readOnly={readOnly}
        />
    </div>
);

export const AmountInput = ({ label, placeholder, value, onChange }) => (
    <div>
        <label className={css.label}>{label}</label>
        <div className={css.inputWrapper}>
            <input
                className={css.input}
                placeholder={placeholder || "Enter Amount"}
                value={value || ""}
                onChange={e => onChange && onChange(e.target.value)}
            />
            <span className={css.iconRight}>
                <img src={rupeeIcon} alt="₹" className={css.rupeeIcon} />
            </span>
        </div>
    </div>
);

export const DateInput = ({ label, value, onChange, placement = "bottom" }) => {
    const validDate = value ? (typeof value === 'string' && value.match(/^\d{2}-\d{2}-\d{4}$/) ? new Date(value.split('-').reverse().join('-')) : new Date(value)) : null;
    return (
        <div>
            {label && <label className={css.label}>{label}</label>}
            <CommonDatePicker
                value={validDate}
                onChange={(newVal) => onChange && onChange(newVal ? dayjs(newVal).format("DD-MM-YYYY") : "")}
                containerClass={css.inputWrapper}
                inputClass={css.input}
                iconStyle={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)" }}
                placement={placement}
            />
        </div>
    );
};


export const StatusBanner = ({
    relationship, 
    onRelChange, 
    beforeShares = 0,
    nowShares = 0,
    beforeOwnership = 0,
    nowOwnership = 0,
    shareDiff = 0,
    ownershipDiff = 0 }) => {
    const numBeforeShares = Number(beforeShares) || 0;
    const numNowShares = Number(nowShares) || 0;
    const numBeforeOwnership = Number(beforeOwnership) || 0;
    const numNowOwnership = Number(nowOwnership) || 0;
    const numShareDiff = Number(shareDiff) || 0;
    const numOwnershipDiff = Number(ownershipDiff) || 0;

    return (
    <div className={css.statusChangedCard}>
        <div className={css.statusChangedTop}>
            <div className={css.statusIconBox}><img src={WarningIcon} alt="note" width={35} height={35}  /></div>
            <div className={css.statusTextBox}>
                <div className={css.statusChangedTitle}>Status Changed! You're now a {relationship || "—"}</div>
                <div className={css.statusChangedSub}>Your ownership crossed 50% granting subsidiary control rights</div>
            </div>
            <div className={css.statusRelSelectWrap}>
                <CustomDropdown
                    label="Nature Of Relationship"
                    options={RELATIONSHIP_OPTIONS}
                    placeholder="Select relationship"
                    value={relationship}
                    onChange={onRelChange}
                />
            </div>
        </div>
        <div className={css.statusChangedBottom}>
            <div className={css.ownershipBlock}>
                <span className={css.ownershipBlockLabel}>BEFORE</span>
                <span className={css.ownershipBigValue}>
                  {numBeforeShares}
                </span>

                <span className={css.ownershipPctGreen}>
                   {numBeforeOwnership.toFixed(2)}% Ownership
                </span>
            </div>
            <div className={css.ownershipArrowCircle}><img src={Arrow} alt="arrow" width={48} height={48} /></div>
            <div className={css.ownershipBlock}>
                <span className={css.ownershipBlockLabel}>NOW</span>
                <div style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
                   <span className={css.ownershipBigValue}>
                      {numNowShares}
                    </span>

                    <span
                    style={{
                        color: numShareDiff < 0 ? "#E5484D" : "#2ECC71",
                        border: `1px solid ${numShareDiff < 0 ? "#E5484D" : "#2ECC71"}`,
                        padding: "2px 8px",
                        borderRadius: "10px",
                        fontWeight: 500
                    }}
                    >
                    {numShareDiff > 0 ? " + " : ""}
                    {numShareDiff}
                    </span>
                </div>
                <div className={css.ownershipNowRow}>
                   <span className={numOwnershipDiff < 0 ? css.ownershipPctRed : css.ownershipPctGreen}>
                      {numNowOwnership.toFixed(2)}% Ownership
                    </span>

                    <span
                    style={{
                        color: numOwnershipDiff < 0 ? "#E5484D" : "#2ECC71",
                        border: `1px solid ${numOwnershipDiff < 0 ? "#E5484D" : "#2ECC71"}`,
                        padding: "2px 8px",
                        borderRadius: "10px",
                        fontWeight: 500
                    }}
                    >
                    {numOwnershipDiff > 0 ? " + " : ""}
                    {numOwnershipDiff.toFixed(2)} %
                    </span>
                 </div>
            </div>
        </div>
    </div>
    );
};


export const NotesOnlyCard = ({ formData, onChange }) => (
    <div className={css.notesOnlyCard}>
        <label className={css.label}>Notes / Remarks</label>
        <textarea
            className={css.notesTextarea}
            placeholder="Placeholder text"
            value={formData.notes || ""}
            onChange={e => onChange("notes", e.target.value)}
        />
    </div>
);


export const AdditionalInfo = ({ formData, onChange, projectOptions, consolList }) => {
    const [otherFields, setOtherFields]           = useState([{ id: 1, fieldLabel: "", amount: "" }]);
    const [isCommonControl, setIsCommonControl]   = useState("NO");
    const [showConfigModal, setShowConfigModal]   = useState(false);
    const [showConsoleEntry, setShowConsoleEntry] = useState(() => {
        const hasData = [
            formData?.nciValue, formData?.consolInvestment,
            formData?.goodWill, formData?.otherInputs,
            formData?.netAssets, formData?.gainOnBargainPurchase
        ].some(v => Number(v) !== 0 && v !== undefined && v !== null);
        return hasData || false;
    });

    useEffect(() => {
        const hasData = [
            formData?.nciValue, formData?.consolInvestment,
            formData?.goodWill, formData?.otherInputs,
            formData?.netAssets, formData?.gainOnBargainPurchase
        ].some(v => Number(v) !== 0 && v !== undefined && v !== null);
        if (hasData) setShowConsoleEntry(true);
    }, [formData?.nciValue, formData?.consolInvestment, formData?.goodWill, formData?.otherInputs, formData?.netAssets, formData?.gainOnBargainPurchase]);
    const [selectedFsType, setSelectedFsType]     = useState("uploadPreset");

    useEffect(() => {
        console.log("SharedComponents - consolList received:", consolList);
        console.log("SharedComponents - projectOptions received:", projectOptions);
    }, [consolList, projectOptions]);

    const addField    = () => setOtherFields(prev => [...prev, { id: Date.now(), fieldLabel: "", amount: "" }]);
    const removeField = (id) => {
    const updated = otherFields.filter(f => f.id !== id);
    setOtherFields(updated);

    const formatted = updated
        .filter(f => f.fieldLabel || f.amount)
        .map(f => ({
            description: f.fieldLabel,
            amount: Number(f.amount) || 0
        }));

    onChange("addOtherDetails", formatted);
};
    const updateField = (id, key, val) => {
    const updated = otherFields.map(f =>
        f.id === id ? { ...f, [key]: val } : f
    );

    setOtherFields(updated);

    const formatted = updated
        .filter(f => f.fieldLabel || f.amount)
        .map(f => ({
            description: f.fieldLabel,
            amount: Number(f.amount) || 0
        }));

    onChange("addOtherDetails", formatted);
};
    return (
        <div style={{ paddingTop: "20px" }}>
        <div className={css.additionalInfoCard}>
            <div className={css.additionalInfoTitle}>Additional Info</div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "15px", padding: "10px 0" }}>
                <div style={{ fontWeight: "500", whiteSpace: "nowrap" }}>
                    Browse Control Date FS
                </div>
                <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
                    <label
                        style={{
                            display: "flex",
                            alignItems: "center",
                            fontWeight: "500",
                            cursor: "pointer",
                        }}
                    >
                        <input
                            type="radio"
                            name="fsTypeSelection"
                            value="uploadPreset"
                            checked={selectedFsType === "uploadPreset"}
                            onChange={(e) => {
                                setSelectedFsType(e.target.value);
                                onChange("FSType", "standalone");
                                onChange("consolID", "");
                            }}
                            style={{ marginRight: "8px" }}
                        />
                        Upload Preset
                    </label>

                    <label
                        style={{
                            display: "flex",
                            alignItems: "center",
                            fontWeight: "500",
                            cursor: "pointer",
                        }}
                    >
                        <input
                            type="radio"
                            name="fsTypeSelection"
                            value="existingConsol"
                            checked={selectedFsType === "existingConsol"}
                            onChange={(e) => {
                                setSelectedFsType(e.target.value);
                                onChange("FSType", "consol");
                                onChange("browseControlDateFS", "");
                            }}
                            style={{ marginRight: "8px" }}
                        />
                        Select Existing Consol FS
                    </label>
                </div>
            </div>

            {selectedFsType === "uploadPreset" && (
                <CustomDropdown
                    label=""
                    options={projectOptions}
                    placeholder="Select Preset"
                    value={formData.browseControlDateFS}
                    onChange={v => onChange("browseControlDateFS", v)}
                />
            )}

            {selectedFsType === "existingConsol" && (
                <CustomDropdown
                    label=""
                    options={consolList || []}
                    placeholder="Select Existing Consol FS"
                    value={formData.consolID}
                    onChange={v => onChange("consolID", v)}
                />
            )}

            <div className={css.addOtherDetailsBox}>
                <div className={css.addOtherDetailsHeader}>
                    <span className={css.addOtherDetailsLabel}>Add Other Details</span>
                    <button className={css.addFieldButton} onClick={addField}>
                        <PlusIcon width={15} height={15} style= {{ marginTop: "-2px" }} /> Add Field
                    </button>
                </div>
                {otherFields.map(f => (
                    <div key={f.id} className={css.otherDetailRow}>
                        <input
                            className={css.input}
                            style={{ flex: 2 }}
                            placeholder="Type something..."
                            value={f.fieldLabel}
                            onChange={e => updateField(f.id, "fieldLabel", e.target.value)}
                        />
                        <div className={css.inputWrapper} style={{ flex: 1 }}>
                            <input
                                className={css.input}
                                style={{ paddingRight: 36 }}
                                placeholder="Enter Amount"
                                value={f.amount}
                                onChange={e => updateField(f.id, "amount", e.target.value)}
                            />
                            <span className={css.iconRight}>
                                <img src={rupeeIcon} alt="₹" className={css.rupeeIcon} />
                            </span>
                        </div>
                        <button className={css.removeFieldBtn} onClick={() => removeField(f.id)}>
                            <RemoveIcon />
                        </button>
                    </div>
                ))}
            </div>

            <div className={css.commonControlRow}>
                <span>Is the transaction covered as common control transaction?</span>
                <div className={css.radioGroupInline}>
                    <label className={css.radioOptionLabel}>
                        <input type="radio" name="commonControl" value="NO" checked={isCommonControl === "NO"} 
                            onChange={() => {
                                setIsCommonControl("NO");
                                onChange("isCommonControlTransaction", false);
                            }}
                        style={{ accentColor: "#3AB67D", cursor: "pointer" }} />
                        No
                    </label>
                    <label className={css.radioOptionLabel}>
                        <input type="radio" name="commonControl" value="YES" checked={isCommonControl === "YES"} 
                        onChange={() => {
                            setIsCommonControl("YES");
                            onChange("isCommonControlTransaction", true);
                        }}
                        style={{ accentColor: "#3AB67D", cursor: "pointer" }} />
                        Yes
                    </label>
                </div>
            </div>

            <div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: 20 }}>
                <button
                    className={css.consoleBtn}
                    style={{ marginBottom: 0 }}
                    onClick={() => setShowConsoleEntry(true)}
                >
                    Create Consol Entry
                </button>
                <button
                    type="button"
                    className={css.consoleBtn}
                    style={{
                        marginBottom: 0,
                        backgroundColor: "#205a46",
                        color: "#ffffff",
                        border: "1px solid #205a46"
                    }}
                    onClick={() => setShowConfigModal(true)}
                >
                    Configure mapping
                </button>
            </div>

            {showConsoleEntry && (
                <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
                    <div className={css.consoleEntryBox} style={{ flex: 1, margin: 0 }}>
                        <div className={css.consoleHeader}>Consol Entry</div>

                        <div className={css.consoleRow}>
                            <span>Non-Controlling Asset</span>
                            <span>{formatIndianNumber(formData.nciValue) || 0}</span>
                        </div>

                        <div className={css.consoleRow}>
                            <span>Investments</span>
                            <span>{formatIndianNumber(formData.consolInvestment) || 0}</span>
                        </div>

                        <div className={css.consoleRow}>
                            <span>Goodwill</span>
                            <span>{formatIndianNumber(formData.goodWill) || 0}</span>
                        </div>

                        <div className={css.consoleRow}>
                            <span>Other inputs</span>
                            <span>{formatIndianNumber(formData.otherInputs) || 0}</span>
                        </div>
                        <div className={css.consoleRow}>
                            <span>Net Assets</span>
                            <span>{formatIndianNumber(formData.netAssets) || 0}</span>
                        </div>

                        <div className={css.consoleRow}>
                            <span>Gain on Bargain Purchase</span>
                            <span>{formatIndianNumber(formData.gainOnBargainPurchase) || 0}</span>
                        </div>
                    </div>

                    {formData.investmentCurrency && (
                        <div className={css.consoleEntryBox} style={{ flex: 1, margin: 0 }}>
                            <div className={css.consoleHeader}>Consol Entry in Subsidiary's Local Currency</div>

                            <div className={css.consoleRow}>
                                <span>Non-Controlling Asset</span>
                                <span>{formatIndianNumber(formData.nciValue) || 0}</span>
                            </div>

                            <div className={css.consoleRow}>
                                <span>Investments</span>
                                <span>{formatIndianNumber(formData.consolInvestment) || 0}</span>
                            </div>

                            <div className={css.consoleRow}>
                                <span>Goodwill</span>
                                <span>{formatIndianNumber(formData.goodWill) || 0}</span>
                            </div>

                            <div className={css.consoleRow}>
                                <span>Other inputs</span>
                                <span>{formatIndianNumber(formData.otherInputs) || 0}</span>
                            </div>
                            <div className={css.consoleRow}>
                                <span>Net Assets</span>
                                <span>{formatIndianNumber(formData.netAssets) || 0}</span>
                            </div>

                            <div className={css.consoleRow}>
                                <span>Gain on Bargain Purchase</span>
                                <span>{formatIndianNumber(formData.gainOnBargainPurchase) || 0}</span>
                            </div>
                        </div>
                    )}
                </div>
            )}

            <ConsolEntryConfigModal
                isOpen={showConfigModal}
                onClose={() => setShowConfigModal(false)}
                fsType={formData.FSType || "standalone"}
                fsId={formData.browseControlDateFS || formData.controlDateFS || ""}
                consolID={formData.consolID}
                mappingValue={formData.autoAdjustmentMapping || []}
                onSave={(mapping) => {
                    if (onChange) {
                        onChange("autoAdjustmentMapping", mapping);
                    }
                }}
            />
        </div>
        </div>
    );
};